module.exports = __webpack_public_path__ + "static/media/BNW_Alphabet_Z.f7b932c0.jpg";